import {
  Button,
  Config,
  Dropdown,
  Flex,
  theme,
  Typography,
  type LanguageType,
} from '@contiple/antd-ds';
import { useTranslation } from 'react-i18next';

import { useLanguageStore } from '@/store';

const LanguageToggle = () => {
  const { token } = theme.useToken();
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguageStore();

  const menuItems = Object.values(Config.Language).map((s) => ({
    key: s as string,
    label: t(`language.${s}`),
  }));

  const handleMenuClick = ({ key }: { key: string }) => {
    setLanguage(key as LanguageType);
  };

  return (
    <Flex gap="8px" align="center" justify="center">
      <Typography.Text style={{ color: token.Layout?.headerColor }}>
        {t('language.title')}:
      </Typography.Text>
      <Dropdown
        menu={{ items: menuItems, onClick: handleMenuClick }}
        placement="bottom">
        <Button>{t(`language.${language}`)}</Button>
      </Dropdown>
    </Flex>
  );
};

export default LanguageToggle;
